export const TopbarTypeEnum = Object.freeze({
  NONE: 'None',
  DEFAULT: 'AppTopbar',
  NAVIGATION: 'AppTopbarNavigation',
});

export const EventBusEnum = Object.freeze({
  TOPBAR_PROCEED: 'TOPBAR_PROCEED',
  TOPBAR_BACK: 'TOPBAR_BACK',
});

export const SeverityEnum = Object.freeze({
  NONE: 'NONE',
  MILD: 'MILD',
  MODERATE: 'MODERATE',
  SEVERE: 'SEVERE',
});

export const PATIENT_ONBOARDING_STATUS = {
  NOT_YET: 0,
  ONBOARDING: 1,
  ONBOARDED: 2,
};

export const TriageEnum = Object.freeze({
  T1: { code: 'T1', level: 'Monitor', color: '#3a7c22' },
  T2: { code: 'T2', level: 'Manage', color: '#e97132' },
  T3: { code: 'T3', level: 'Escalate', color: '#c00000' },
  T4: { code: 'T4', level: 'Urgent', color: '#ee0000' },
});

export const TreatmentTypeEnum = Object.freeze({
  SURGERY: 'SURGERY',
  CHEMOTHERAPY: 'CHEMOTHERAPY',
  RADIATION: 'RADIATION',
});

export const LOCAL_STORAGE_KEY = {
  TOKEN: '__TOKEN',
  PATIENT_MAIN_UNIQUE: '__PATIENT_MAIN_UNIQUE',
  REMINDER_DELAY_KEY: '__REMINDER_DELAY_KEY',
};

export const SYMPTOM_TYPE = Object.freeze({
  IMMEDIATE: 'IMMEDIATE',
  EARLY: 'EARLY',
  LATE: 'LATE',
});

export const COLOR_PALETTE = ['#00786F', '#A7B029', '#615FFF', '#F79F1F'];

export const GradeCodeEnum = Object.freeze({
  G0: { severity: 'NONE', label: 'Not Felt (Grade 0)', severityCode: 'G0' },
  G1: { severity: 'MILD', label: 'Mild (Grade 1)', severityCode: 'G1' },
  G2: { severity: 'MODERATE', label: 'Moderate (Grade 2)', severityCode: 'G2' },
  G3: { severity: 'SEVERE', label: 'Severe (Grade 3)', severityCode: 'G3' },
});

export const TeleAppointmentPlatformEnum = [
  { code: 'VOICE_CALL', name: 'Voice Call' },
  { code: 'WHATSAPP', name: 'WhatsApp Call' },
];

export const ActiveSymptomTrendEnum = {
  NO_CHANGE: { code: 'NO_CHANGE', label: 'Unchanged' },
  WORSENED: { code: 'WORSENED', label: 'Worsened' },
  IMPROVED: { code: 'IMPROVED', label: 'Improved' },
};

const NavigationRouteEnum = [
  { code: 'NAVIGATOR_TELEPHARMACY', name: 'tele-pharmacy' },
  { code: 'TELEPHARMACY_ORDER', name: 'tele-pharmacy' },
  { code: 'DEFAULT_NAVIGATOR', name: 'navigator' },
  { code: 'MY_ORDER_DETAIL', name: 'my-order-detail' },
  { code: 'MY_ORDERS', name: 'my-orders' },
  { code: 'MEDICATION', name: 'medication-home' },
  { code: 'TELE_PHARMACY_CONFIRMATION', name: 'tele-pharmacy-confirmation' },
];

export const getRouteName = (code) => {
  const found = NavigationRouteEnum.find((item) => item.code === code);
  return found ? found.name : 'navigator';
};

export const PrescriptionStatusEnum = Object.freeze({
  PENDING: 'PENDING',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
});

export const OrderStatusEnum = Object.freeze({
  INQUEUE: { code: 'INQUEUE', label: 'IN QUEUE' },
  MISSEDQUEUE: { code: 'MISSEDQUEUE', label: 'MISSED QUEUE' },
  CANCELED: { code: 'CANCELED', label: 'CANCELED' },
  INTRANSIT: { code: 'INTRANSIT', label: 'IN TRANSIT' },
  COMPLETED: { code: 'COMPLETED', label: 'COMPLETED' },
});

export const MEDICATION_ORDER_COLLECTION_METHOD = {
  SELF_COLLECTION: 'SELF_COLLECTION',
  HOME_DELIVERY: 'HOME_DELIVERY',
};

export const MedicationScheduleStatusEnum = Object.freeze({
  NOT_TAKEN: 'NOT_TAKEN',
  TAKEN: 'TAKEN',
  SKIPPED: 'SKIPPED',
});

export const INTAKE_STATUS = Object.freeze({
  TAKEN: 'taken',
  SKIP: 'skip',
  RESCHEDULE: 'reschedule',
});

export const MedicationOrderMethodEnum = Object.freeze({
  SELF_COLLECTION: { code: 'SELF_COLLECTION', label: 'Self Collection' },
  HOME_DELIVERY: { code: 'HOME_DELIVERY', label: 'Home Delivery' },
});

export const UpcomingEventTypeEnum = [
  { code: 'tele_pharmacy', name: 'Tele Pharmacy' },
  { code: 'appointment', name: 'Appointment' },
];

export const INTAKE_DAILY_STATUS = {
  NO_DOSE_SCHEDULED: 'no-dose-scheduled',
  ALL_DOSES_TAKEN: 'all-doses-taken',
  SOME_DOSES_TAKEN: 'some-doses-taken',
  SKIPPED_DOSES: 'skipped-doses',
  MISSED_DOSES: 'missed-doses',
};

export const DEFAULT_PHOTO = '/images/common/no-image-available.jpg';

export const DEFAULT_MEDICATION_REMINDER_CARD = '/images/common/default-photo-card.jpg';
